module.exports = __webpack_public_path__ + "img/education4.c1b6d4fe.jpeg";